import React, { useCallback, useEffect, useState } from "react";
import { Dropdown, Icon, DatePicker } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;
export default function StatisticPeriod({ onChange }) {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [title, setTitle] = useState('Today');
  const onDropdownVisible = useCallback((visible) => {
    setDropdownVisible(visible)
  }, []);

  useEffect(() => {
    typeof onChange === 'function' && onChange([
      moment().startOf('day').format(),
      moment().endOf('day').format()
    ])
  }, [])

  const overlay = (
    <div>
      <RangePicker
        // defaultValue={defaultValue}
        ranges={{
          Today: [moment().startOf('day'), moment().endOf('day'), 'Today'],
          Yesterday: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day'), 'Yesterday'],
          'This Week': [moment().startOf('week'), moment().endOf('week'), 'This Week'],
          'This Month': [moment().startOf('month'), moment().endOf('month'), 'This Month'],
          'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter'), 'This Quarter'],
        }}
        onChange={(range) => {
          if (onChange) {
            onChange(range.length
              ? [
                range[0].format(),
                range[1].format()
              ]
              : [
                moment().startOf('day').format(),
                moment().endOf('day').format()
              ]);
          }
          setTitle(
            range[2] ||
            (range.length
              ? range[0].isSame(range[1], "date")
                ? range[0].format('MMM DD, YYYY')
                : `${range[0].format('MMM DD, YYYY')} - ${range[1].format('MMM DD, YYYY')}`
              : 'Today')
          );
        }}
        onOpenChange={(isOpen) => {
          setDropdownVisible(isOpen);
        }}
      />
    </div>
  )

  return (
    <Dropdown overlay={overlay} trigger={['click']} onVisibleChange={onDropdownVisible} visible={dropdownVisible}>
      <b style={{ textDecorationStyle: 'dashed', cursor: 'pointer' }}>{title} <Icon type="down"/></b>
    </Dropdown>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/StatisticsPeriod.js